import { Box, styled } from '@mui/material';

const Container = styled(Box)`
  width: 100%;
  height: 104px;
  border: 1px solid;
  border-color: ${({ theme }) => theme.palette.divider};
  border-radius: 4px;
  padding: 4px;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`;

export default Container;
